const accountingIT = {
    "view": {
        "table": {
            "title": "Elenco Contabilità",
            "column": {
                "release": "Rilascio",
                "period": "Periodo",
                "royalties": "Royalties",
                "costs": "Costi",
                "net_revenue": "Ricavo Netto",
                "status": "Stato",
                "accounting_report": "Rapporto Contabile",
                "details": "Dettagli"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "statusCreating": "Creazione",
                "statusGenerating": "Generazione",
                "statusGenerated": "Generato",
                "statusNotGenerated": "Non Generato",
                "open": "Apri",
                "downloadPDF": "Scarica PDF",
                "generatingPDF": "Generazione PDF",
                "exportCsv": "Esporta CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Il tuo piano di abbonamento attuale non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filtri",
                "monthRange": "Intervallo Mesi",
                "release": "Rilascio"
            },
            "options": {
                "allReleases": "Tutti i Rilasci"
            },
            "placeholder": {
                "startingMonth": "Mese di Inizio",
                "endingMonth": "Mese di Fine"
            },
            "button": {
                "generate": "Genera Rapporto Contabile",
                "reset": "Reimposta Filtri"
            },
            "table": {
                "title": "Guadagni disponibili per la contabilità",
                "columns": {
                    "month": "Mese",
                    "year": "Anno",
                    "revenue": "Ricavo",
                    "status": "Stato"
                },
                "label": {
                    "status_open": "Aperto",
                    "status_accounted": "Contabilizzato",
                    "month_january": "Gennaio",
                    "month_february": "Febbraio",
                    "month_march": "Marzo",
                    "month_april": "Aprile",
                    "month_may": "Maggio",
                    "month_june": "Giugno",
                    "month_july": "Luglio",
                    "month_august": "Agosto",
                    "month_september": "Settembre",
                    "month_october": "Ottobre",
                    "month_november": "Novembre",
                    "month_december": "Dicembre"
                }
            }
        },
        "modal": {
            "header": "Aggiungi Contabilità",
            "body": "Sei sicuro di voler aggiungere una nuova contabilità per Rilascio: {{release}}, PERIODO: {{startingMonth}} A {{endingMonth}} ?"
        },
        "message": {
            "success": "La contabilità è stata creata!",
            "errorSomethingWentWrong": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "errorNoEarningsAvailable": "Nessun guadagno disponibile per la contabilità.",
            "errorNoReleaseSelected": "Seleziona un rilascio particolare per la contabilità."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Dettaglio Contabilità",
                "column": {
                    "revenueShareHolder": "Azionista",
                    "revenue": "Royalty Netta Azionista",
                    "reportPdf": "Scarica PDF",
                    "action": "Azione",
                    "emailSent": "Email Inviata"
                },
                "label": {
                    "downloadPDF": "Scarica PDF",
                    "generatingPDF": "Generazione PDF"
                },
                "button": {
                    "exportCsv": "Esporta CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Invia Rapporto all'Azionista",
                        "body": "Sei sicuro di voler inviare il rapporto all'azionista?",
                        "message": {
                            "success": "Rapporto inviato con successo!"
                        },
                        "button": {
                            "cancel": "Annulla",
                            "confirm": "Conferma"
                        }
                    }
                },
                "message": {
                    "success": "Il rapporto contabile è stato inviato!",
                    "errorSomethingWentWrong": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
                    "errorEmailNotPresent": "Email per l'azionista non presente!",
                    "errorNoReportAvailable": "Nessun rapporto disponibile per questo rilascio."
                }
            }
        }
    }
};

export default accountingIT;